export const patrikaData = [
  {
    month: "February",
    year: "2026",
    pdf: "feb-2026",
  },
  {
    month: "January",
    year: "2026",
    pdf: "jan-2026",
  },
  {
    month: "December",
    year: "2025",
    pdf: "dec-2025",
  },
  {
    month: "November",
    year: "2025",
    pdf: "nov-2025",
  },
  {
    month: "October",
    year: "2025",
    pdf: "oct-2025",
  },
  {
    month: "September",
    year: "2025",
    pdf: "sep-2025",
  },
  {
    month: "August",
    year: "2025",
    pdf: "aug-2025",
  },
  {
    month: "July",
    year: "2025",
    pdf: "july-2025",
  },
  {
    month: "June",
    year: "2025",
    pdf: "jun-2025",
  },
  {
    month: "May",
    year: "2025",
    pdf: "may-2025",
  },
  {
    month: "April",
    year: "2025",
    pdf: "apr-2025",
  },
  {
    month: "March",
    year: "2025",
    pdf: "mar-2025",
  },
  {
    month: "February",
    year: "2025",
    pdf: "feb-2025",
  },
  {
    month: "January",
    year: "2025",
    pdf: "jan-2025",
  },
  {
    month: "December",
    year: "2024",
    pdf: "dec-2024",
  },
  {
    month: "November",
    year: "2024",
    pdf: "nov-2024",
  },
  {
    month: "October",
    year: "2024",
    pdf: "oct-2024",
  },
  {
    month: "September",
    year: "2024",
    pdf: "sep-2024",
  },
  {
    month: "August",
    year: "2024",
    pdf: "aug-2024",
  },
  {
    month: "July",
    year: "2024",
    pdf: "jul-2024",
  },
  {
    month: "June",
    year: "2024",
    pdf: "jun-2024",
  },
  {
    month: "May",
    year: "2024",
    pdf: "may-2024",
  },
  {
    month: "April",
    year: "2024",
    pdf: "apr-2024",
  },
  {
    month: "March",
    year: "2024",
    pdf: "mar-2024",
  },
  {
    month: "February",
    year: "2024",
    pdf: "feb-2024",
  },
  {
    month: "January",
    year: "2024",
    pdf: "jan-2024",
  },
  {
    month: "December",
    year: "2023",
    pdf: "dec-2023",
  },
  {
    month: "November",
    year: "2023",
    pdf: "nov-2023",
  },
  {
    month: "October",
    year: "2023",
    pdf: "oct-2023",
  },
  {
    month: "September",
    year: "2023",
    pdf: "sep-2023",
  },
  {
    month: "August",
    year: "2023",
    pdf: "aug-2023",
  },
  {
    month: "July",
    year: "2023",
    pdf: "jul-2023",
  },
  {
    month: "June",
    year: "2023",
    pdf: "jun-2023",
  },
  {
    month: "May",
    year: "2023",
    pdf: "may-2023",
  },
  {
    month: "April",
    year: "2023",
    pdf: "apr-2023",
  },
  {
    month: "March",
    year: "2023",
    pdf: "mar-2023",
  },
  {
    month: "February",
    year: "2023",
    pdf: "feb-2023",
  },
  {
    month: "January",
    year: "2023",
    pdf: "jan-2023",
  },
  {
    month: "December",
    year: "2022",
    pdf: "dec-2022",
  },
];

export const framilyTreeData = [
  {
    pdf: "bhadran.pdf",
  },
  {
    pdf: "dharmaj.pdf",
  },
  {
    pdf: "karamsad.pdf",
  },
  {
    pdf: "nadiad.pdf",
  },
  {
    pdf: "sojitra.pdf",
  },
  {
    pdf: "vaso.pdf",
  },
  {
    pdf: "savli.pdf",
  },
];
